import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWorkoutHistory } from "../../api/workoutHistoryApi";
import * as Endpoints from "../../entities/Endpoints";

export const fetchWorkoutHistoryThunk = createAsyncThunk(
  Endpoints.GET_WORKOUT_HISTORY,
  async ({ clientId, coachId }, { rejectWithValue }) => {
    try {
      const data = fetchWorkoutHistory({ clientId, coachId });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const workoutHistorySlice = createSlice({
  name: "getWorkoutHistory",
  initialState: {
    workoutHistoryList: null,
    isloading: false,
    error: null,
    successMessage: null,
    updateSuccessMessage: "",
    updateFailedMessage: "",
  },
  reducers: {
    clearUpdateMessage: (state) => {
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    },
    resetWorkoutHistory: (state) => {
      state.workoutHistoryList = null;
      state.isloading = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkoutHistoryThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
        state.updateSuccessMessage = "";
        state.updateFailedMessage = "";
      })
      .addCase(fetchWorkoutHistoryThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.workoutHistoryList = action.payload;
      })
      .addCase(fetchWorkoutHistoryThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
      });
  },
});
export const { clearUpdateMessage, resetWorkoutHistory } =
  workoutHistorySlice.actions;
export const WorkoutHistoryReducer = workoutHistorySlice.reducer;
